import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { CSearchSlideListItem } from '@/components/modules/pages/consultantSearch/List/CSearchSlideListItem';
import { PSearchSlideList } from '@/components/modules/pages/proffitSearch/List/PSearchSlideList';
import { PSearchSlideListItemSkeleton } from '@/components/modules/pages/proffitSearch/List/PSearchSlideListItem';
import { useArrayWithIndex } from '@/hooks/array/useArrayWithIndex';
import { propBool, propShape } from '../../../../helpers/custom-prop-types';
const ConsultantPsSearchSlide = (props) => {
    const { isShow, psSlidePage: { initialLoaded, list }, } = props;
    /** スケルトン表示用のダミー配列 */
    const dummies = useArrayWithIndex(6);
    return (_jsx("div", Object.assign({ className: clsx('search_list_block_all ps_search_slide_block_list', !isShow && 'is-dnone') }, { children: _jsx(PSearchSlideList, Object.assign({ className: 'slide_search_list_content_items ps_search_slide_block_wrapper' }, { children: initialLoaded
                ? list.map((slide) => (_jsx(CSearchSlideListItem, { slide: slide, slides: list }, `${slide.id}_${slide.slideSearchSlideUuid}`)))
                : dummies.map(({ index }) => (_jsx(PSearchSlideListItemSkeleton, {}, index))) })) })));
};
ConsultantPsSearchSlide.propTypes = {
    isShow: propBool().isRequired,
    psSlidePage: propShape().isRequired,
};
export default ConsultantPsSearchSlide;
